import { render, staticRenderFns } from "./detailMonthlyYearPlan.vue?vue&type=template&id=5b2f1561&scoped=true&"
import script from "./detailMonthlyYearPlan.vue?vue&type=script&lang=js&"
export * from "./detailMonthlyYearPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f1561",
  null
  
)

export default component.exports